import { BasicModel } from "../basic/basic.model";
import { BasicWithLibelleModel } from "../basic/basicWithLibelle.model";
import { SocieteModel } from "../simple-types/societe.model";

export class SocieteLinkedModel extends BasicModel implements BasicWithLibelleModel {
    // max 9
    code: string;
    // max 50
    libelle: string;

    idSociete: number = -1;
    societe: SocieteModel;
}
